import { Checkbox, Typography } from "@fullscript/aviary-web";
import type { FormEvent } from "react";
import { Trans } from "react-i18next";

import { Link } from "@aviary";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { l } from "@shared/locales/i18n";

import * as styles from "./TermsCheckbox.styles";

interface Props {
  onChange: (event: FormEvent<HTMLInputElement>) => void;
  checked: boolean;
  hasError?: boolean;
}
const TERMS_OF_SERVICE_URL = "https://fullscript.com/terms-of-service";

const TermsCheckbox = ({ onChange, checked, hasError }: Props) => {
  const linkColor = hasError ? "warning" : "success";

  return (
    <Checkbox
      onChange={onChange}
      checked={checked}
      aria-invalid={hasError ? true : undefined}
      data-e2e={hasError ? "tos-error" : undefined}
    >
      <Typography
        variant="footnote"
        customCss={hasError ? styles.termsCheckboxError : styles.termsCheckbox}
      >
        <Trans
          i18nKey={l.signin.TermsOfServiceCheckboxLabel}
          components={{
            tos: <Link isColor={linkColor} href={TERMS_OF_SERVICE_URL} noExternalIcon />,
            privacy: (
              <Link isColor={linkColor} href={sharedRoutes.external.privacyPolicy} noExternalIcon />
            ),
          }}
        />
        <span css={styles.asterisk}>*</span>
      </Typography>
    </Checkbox>
  );
};

export { TermsCheckbox };
